"use client"; // Required for client-side navigation in Next.js app directory
import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
// import "../styles/globals.css";
// import "../EcommerceBot/styles/globals.css";
import "./styles/globals.css";
import axios from "axios";
import Header from "./header";

const Home = () => {
  const location = useLocation();
  const [showLibraryScreen, setShowLibraryScreen] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    protocol: "http(s)",
    url: "",
    headers: [{ key: "", value: "" }],
  });
  console.log("FormData: ", formData);
  const [options, setOptions] = useState([]); // State to store API response
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [question, setQuestion] = useState("");
  const [matchingKeys, setMatchingKeys] = useState([]); // State for storing matching keys
  const [debounceTimeout, setDebounceTimeout] = useState(null); // Debounce timeout
  const [integrationDetails, setIntegrationDetails] = useState([]);
  const [isUpdateClicked, setIsUpdateClicked] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuestion(value); // Immediately update the input value in state
    // Clear previous debounce timeout if user is still typing
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    // Set a new timeout for the API call after a short delay (debouncing)
    const timeout = setTimeout(() => {
      // fetchMatchingKeys(value); // Pass the updated value to the fetch function
    }, 500); // Adjust the delay time as needed (500ms here)
    setDebounceTimeout(timeout); // Store the new timeout ID
  };

  const handleKeySelect = (key) => {
    setQuestion(key); // Set the selected key as the value in the input
    setMatchingKeys([]); // Clear the matching keys list once a key is selected
  };

  const handleHeaderChange = (index, event) => {
    const { name, value } = event.target;
    const newHeaders = [...formData.headers];

    // Update the value of the changed input field
    newHeaders[index][name] = value;
    setFormData({ ...formData, headers: newHeaders });

    // Condition to add a new row if the last input has a value
    if (
      name === "key" &&
      value.length === 1 &&
      index === newHeaders.length - 1
    ) {
      // Add a new empty row only if it's the last row
      setFormData({
        ...formData,
        headers: [...newHeaders, { key: "", value: "" }],
      });
    }

    // Condition to remove the last row if it is empty
    if (
      name === "key" &&
      value.length === 0 &&
      index === newHeaders.length - 2
    ) {
      // Check if the last row is empty
      setFormData({
        ...formData,
        headers: newHeaders.slice(0, -1),
      });
    }
  };

  const addHeader = () => {
    setFormData({
      ...formData,
      headers: [...formData.headers, { key: "", value: "" }],
    });
  };

  const handleShowLibrary = () => {
    setShowLibraryScreen(!showLibraryScreen);
  };

  //cache keys
  // Function to call the matching keys API
  // const fetchMatchingKeys = async (query) => {
  //   if (!query.trim()) {
  //     setMatchingKeys([]); // Clear matching keys if query is empty
  //     return;
  //   }
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `http://alb-cqube-01-730511902.us-east-1.elb.amazonaws.com/get_matching_keys`, // Use POST request
  //       { query: query }, // Send the query as part of the request body as JSON
  //       {
  //         headers: {
  //           "Content-Type": "application/json", // Content type is JSON
  //           Accept: "application/json", // Expect a JSON response
  //         },
  //       }
  //     );
  //     if (response.status === 200) {
  //       console.log("keys: ", response.data);
  //       setMatchingKeys(response.data); // Assuming the API returns an array of keys
  //     } else {
  //       setMatchingKeys([]); // Handle case where no matching keys are found
  //     }
  //   } catch (error) {
  //     console.error("Error fetching matching keys:", error);
  //     setMatchingKeys([]); // Handle errors gracefully
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Function to call API when "Show options" button is clicked
  // const handleShowOptions = async () => {
  //   setIntegrationDetails([]);
  //   setLoading(true);
  //   setError(null);
  //   // console.log("deepika")
  //   try {
  //     const token = localStorage.getItem("token");
  //     console.log("token in get_answer", token);
  //     const response = await axios.post(
  //       `http://alb-cqube-01-730511902.us-east-1.elb.amazonaws.com/get_answer`,
  //       { question, type: "integration" },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Authorization": `Bearer ${token}` // Add your bearer token here
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       console.log("response", response.data);
  //       setIntegrationDetails(response.data.Integration_details || []);
  //     } else {
  //       throw new Error("Failed to fetch options");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     setError(error.message);
  //   } finally {
  //     setLoading(false); // Stop loading
  //   }
  // };

  // Show welcome page only on the main /EcommerceBot route
  if (location.pathname === "/EcommerceBot") {
    return (
      <div className="bg-dark text-light d-flex min-vh-100 justify-content-center align-items-center">
        <Header />
        <div className="w-full max-w-4xl p-8 bg-dark-2 rounded-md shadow-lg">
          <h1 className="text-3xl font-bold mb-8 text-center">Welcome to cQube Ecommerce Bot</h1>
          
          <div className="space-y-6">
            <div className="bg-gray-800 p-6 rounded-lg">
              <h2 className="text-xl font-semibold mb-4">What is cQube Ecommerce Bot?</h2>
              <p className="text-gray-300">
                cQube Ecommerce Bot is an intelligent integration platform that helps you seamlessly connect your ecommerce systems with various third-party services and applications. It simplifies the process of managing integrations, endpoints, and data models for your ecommerce operations.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <h2 className="text-xl font-semibold mb-4">How does it work?</h2>
              <p className="text-gray-300">
                The platform provides a user-friendly interface to create and manage integrations, configure endpoints, and define data models. You can easily set up webhooks, manage API connections, and handle data transformations without writing complex code.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // For other routes, show the regular content with header and outlet
  return (
    <div className="bg-dark text-light d-flex min-vh-100 justify-content-center align-items-center">
      <Header />
      <Outlet />
    </div>
  );
};

export default Home;
